import { ElMessage } from "element-plus";

export default {
  methods: {
    notification({ type, message }) {
      ElMessage({
        type,
        message,
      });
    },
  },
};
